import { ILoginUserData, ICurrentHover, ILockedModal } from "../Models/Models";
import { IBaseAction } from "../Actions/BaseAction";

/** user */
export type SetFetchingLoginUserDataAction  = IBaseAction<boolean>;
export type GetLoginUserDataAction  = IBaseAction<null>;
export type GetLoginUserDataSuccessAction  = IBaseAction<ILoginUserData>;
export type GetLoginUserDataFailureAction  = IBaseAction<string>;
/* hover */
export type SetCurrentHoverAction  = IBaseAction<ICurrentHover>;
export type SetLockedModalAction  = IBaseAction<ILockedModal>;

export type LoginActionType =
    SetFetchingLoginUserDataAction |
    GetLoginUserDataAction |
    GetLoginUserDataSuccessAction |
    GetLoginUserDataFailureAction |
    SetCurrentHoverAction |
    SetLockedModalAction;

/** user */
export const SET_FETCHING_LOGIN_USER_DATA = "SET_FETCHING_LOGIN_USER_DATA";
export const GET_LOGIN_USER_DATA = "GET_LOGIN_USER_DATA";
export const GET_LOGIN_USER_DATA_SUCCESS = "GET_LOGIN_USER_DATA_SUCCESS";
export const GET_LOGIN_USER_DATA_FAILURE = "GET_LOGIN_USER_DATA_FAILURE";
/* hover */
export const SET_CURRENT_HOVER = "SET_CURRENT_HOVER";
export const SET_LOCKED_MODAL = "SET_LOCKED_MODAL";
